"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsonSchema = exports.fromString = exports.empty = exports.isUuid = exports.regex = exports.uuid = void 0;

var uuid_1 = require("uuid");

var uuidv4 = function uuidv4() {
  return uuid_1.v4();
};

exports.uuid = uuidv4;
var regex = {
  v4: /(?:^[0-9a-f]{8}\x2D[0-9a-f]{4}\x2D4[0-9a-f]{3}\x2D[0-9a-f]{4}\x2D[0-9a-f]{12}$)|(?:^0{8}\x2D0{4}\x2D0{4}\x2D0{4}\x2D0{12}$)/,
  v5: /(?:^[0-9a-f]{8}\x2D[0-9a-f]{4}\x2D5[0-9a-f]{3}\x2D[0-9a-f]{4}\x2D[0-9a-f]{12}$)|(?:^0{8}\x2D0{4}\x2D0{4}\x2D0{4}\x2D0{12}$)/
};
exports.regex = regex;
var jsonSchema = {
  /* eslint-disable @typescript-eslint/no-base-to-string */
  v4: {
    type: 'string',
    pattern: regex.v4.toString().slice(1, -1)
  },
  v5: {
    type: 'string',
    pattern: regex.v5.toString().slice(1, -1)
  }
  /* eslint-enable @typescript-eslint/no-base-to-string */

};
exports.jsonSchema = jsonSchema;

var isUuid = function isUuid(value) {
  return regex.v4.test(value) || regex.v5.test(value);
};

exports.isUuid = isUuid;

var empty = function empty() {
  return '00000000-0000-0000-0000-000000000000';
};

exports.empty = empty;

var fromString = function fromString(text) {
  var namespace = 'bb5d0ffa-9a4c-4d7c-8fc2-0a7d2220ba45';
  var uuidFromString = uuid_1.v5(text, namespace);
  return uuidFromString;
};

exports.fromString = fromString;